module.exports = __webpack_public_path__ + "static/img/jpFlag.cd462cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header/jpFlag.svg
// module id = sdXF
// module chunks = 55